export const sowingHandleSubmit = async (items) => {
  // Get seed varieties
  let seedVarieties;
  const token = sessionStorage.getItem("token");
  const response0 = await fetch(
    `${process.env.REACT_APP_API_URL}/admin_sowing/seed_varieties`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    }
  );
  seedVarieties = await response0.json();
  // Items should break out if anything is missing in even one column
  for (let i = 0; i < items.length; i++) {
    // Check if all the required fields are available removed !items[i].germination || because gul bhai did not have it
    if (!items[i].district || !items[i].district_id || !items[i].year) {
      return { message: "Missing items." };
    }
  }

  // Sowing array
  const submitSowing = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    // Compile fields so that items that are not needed
    const sowing = {
      district: String(item.district).trim(),
      district_id: String(item.district_id).trim(),
      year: String(item.year),
    };

    let loosing_crop_array;
    let loosing_amount_array;
    let gaining_crop_array;
    let gaining_amount_array;

    // Loosing array
    let loosing = [];
    if (item.loosing_crop || item.loosing_amount) {
      loosing_crop_array = item.loosing_crop.split(",");
      loosing_amount_array = item.loosing_amount.split(",");
      // Check if they are equal length so that each item has its corresponding amount and crop
      if (loosing_amount_array.length !== loosing_crop_array.length) {
        return { message: "Gaining/loosing crop and amount should be equal." };
      }
      for (let j = 0; j < loosing_crop_array.length; j++) {
        loosing.push({
          amount: parseFloat(loosing_amount_array[j]),
          crop: String(loosing_crop_array[j]).trim(),
        });
      }
      sowing.loosing = loosing
    }
    
    let gaining = [];
    if (item.gaining_crop || item.gaining_amount) {
      // Gaining crop
      gaining_crop_array = item.gaining_crop.split(",");
      gaining_amount_array = item.gaining_amount.split(",");
      // Check if they are equal length so that each item has its corresponding amount and crop
      if (gaining_amount_array.length !== gaining_crop_array.length) {
        return { message: "Gaining/loosing crop and amount should be equal." };
      }
      for (let j = 0; j < gaining_crop_array.length; j++) {
        gaining.push({
          amount: parseFloat(gaining_amount_array[j]),
          crop: String(gaining_crop_array[j]).trim(),
        });
      }

      sowing.gaining = gaining
    }

    // Get seed data
    const seedsAvailable = item.seeds.split(",");
    
    let seedsGermination;
    if(item.germination){
        seedsGermination = item.germination.split(",");
    }

    for (let j = 0; j < seedsAvailable.length; j++) {
      // Get the object that contains information about the specific seed we are on
      const seedValues = seedVarieties.filter(
        (variety) => variety.seed_name === seedsAvailable[j]
      );
      if (seedValues.length === 0) {
        alert(`Seed not found: ${seedsAvailable[j]} which is on the ${j+1} position of the ${i+2} record. Either remove this from the excel file, or find its seed varieties information and add it to the seed varieties table and then reupload this information.`)
        return { message: "Seed not found." };
      }

      const sowingCombinbedField = { ...sowing };

      if (seedValues[0]) {
        if (seedValues[0]?.seed_name)
          sowingCombinbedField.seed_name = seedValues[0].seed_name;
        if (seedValues[0]?.crop)
            sowingCombinbedField.crop = seedValues[0].crop;
        if (seedValues[0]?.seed_varieties)
          sowingCombinbedField.seed_varieties = seedValues[0].seed_varieties;
        if (seedValues[0]?.year_of_release)
          sowingCombinbedField.year_of_release = seedValues[0].year_of_release;
        if (seedValues[0]?.manufacturers)
          sowingCombinbedField.manufacturers = seedValues[0].manufacturers;
        if (seedValues[0]?.sowing_time)
          sowingCombinbedField.sowing_time = seedValues[0].sowing_time;
        if (seedValues[0]?.germination_percent)
          sowingCombinbedField.germination_percent =
            seedValues[0].germination_percent;
        if (seedValues[0]?.yield_potential_mounds_acre)
          sowingCombinbedField.yield_potential_mounds_acre =
            seedValues[0].yield_potential_mounds_acre;
        if (seedValues[0]?.recommended_areas)
          sowingCombinbedField.recommended_areas =
            seedValues[0].recommended_areas;
        if (seedValues[0]?.pests_resistant)
          sowingCombinbedField.pests_resistant = seedValues[0].pests_resistant;
      }

      // Push this to the array
      submitSowing.push(sowingCombinbedField);
    }
  }

  return submitSowing;
};
